import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Card,
  CardMedia,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { withApiBase, buildImageUrl } from "../lib/api";

const ProductPage = () => {
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(10);
  const [selectedVariant, setSelectedVariant] = useState("");
  const { productId } = useParams(); // cria a variavel product ID baseado no parametro que vem da url
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  useEffect(() => {
    fetch(withApiBase(`/api/products/${productId}`))
      .then((res) => res.json())
      .then((data) => setProduct(data))
      .catch((error) => console.error("Error al buscar producto:", error));
      console.log('product: ', productId);
  }, [productId]);

  if (!product) {
    return <Typography>Carregando...</Typography>;
  }

  return (
    <Box sx={{ maxWidth: "1200px", margin: "auto", p: 3 }}>
      <Grid container spacing={3}>
        {/* Coluna de miniaturas */}
        <Grid item xs={12} md={2}>
          <Box sx={{
            display: "flex",
            flexDirection: isMobile ? "row" : "column",
            gap: 2,
            overflowX: isMobile ? "auto" : "visible",
            pb: isMobile ? 2 : 0
          }}>
            {product.images.map((img, index) => (
              <Card key={index} sx={{
                flexShrink: 0,
                width: isMobile ? 100 : "100%",
                border: "2px solid #f5f5f5",
                borderRadius: "8px",
                transition: "transform 0.2s",
                "&:hover": { transform: "scale(1.05)" }
              }}>
                <CardMedia
                  component="img"
                  sx={{ aspectRatio: "1", objectFit: "contain" }}
                  image={buildImageUrl(`/images/products/${img}`)}
                />
              </Card>
            ))}
          </Box>
        </Grid>

        {/* Imagem principal */}
        <Grid item xs={12} md={4}>
          <Card sx={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: 3,
            height: "100%",
            display: "flex"
          }}>
            <CardMedia
              component="img"
              sx={{ objectFit: "contain", width: "100%" }}
              image={buildImageUrl(`/images/products/${product.images[0]}`)}
            />
          </Card>
        </Grid>

        {/* Informações do produto */}
        <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            {product.name}
          </Typography>
          
          <Typography variant="body1" sx={{ 
            color: "text.secondary",
            mb: 3,
            flexGrow: 1,
            lineHeight: 1.6
          }}>
            {product.description}
          </Typography>

          <Box sx={{ bgcolor: "#f8f8f8", p: 2, borderRadius: 2, mb: 3 }}>
            <Typography variant="h5" color="primary" fontWeight={700}>
              {product.price} €
            </Typography>
          </Box>

            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" fontWeight={600} gutterBottom sx={{ fontSize: '0.95rem' }}>
                Variantes:
              </Typography>
              <ToggleButtonGroup
                value={selectedVariant}
                exclusive
                onChange={(e, newVariant) => setSelectedVariant(newVariant)}
                sx={{ gap: 1 }}
              >
                {product.models.map((model) => (
                  <ToggleButton
                    key={model}
                    value={model}
                    sx={{
                      textTransform: "none",
                      borderRadius: "6px!important", // Reduzido
                      border: "1px solid!important", // Borda mais fina
                      fontSize: '0.85rem',
                      px: 1.5, // Padding horizontal reduzido
                      py: 0.5  // Padding vertical reduzido
                    }}
                  >
                    {model}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Box>

            <Box sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              flexWrap: "wrap"
            }}>
              <TextField
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                inputProps={{ min: 1 }}
                sx={{ width: 100 }} // Campo mais estreito
                variant="outlined"
                size="small"
              />
              <Button
                variant="contained"
                color="error"
                size="medium" // Tamanho médio
                sx={{
                  fontWeight: 600, // Fonte um pouco mais fina
                  px: 3, // Padding reduzido
                  py: 1,
                  borderRadius: "6px",
                  boxShadow: 1,
                  fontSize: '0.9rem'
                }}
              >
                COMPRAR AHORA
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Detalhes Técnicos */}
      <Box sx={{
        mt: 4,
        bgcolor: "#f5f5f5",
        p: 3,
        borderRadius: "12px",
        boxShadow: 1
      }}>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          Detalles Técnicos del Producto
        </Typography>
        <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
          {product.details}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProductPage;
